import React from 'react'
import { withRouter } from 'react-router'

import LanguageBar from 'core/languagebar'
import getUrlParameters from 'getUrlParameters'
import getStrings from 'getStrings'

const SchoolZoneHeader = (props) => {
    const strings = getStrings()

    return (
        <header className='schoolzone-header'>
            <div className='container flex-row flex-nowrap padding-top-2'>
                <LanguageBar />
                <div className='margin-left-auto'>
                    <a href={`/signin/?${getUrlParameters()}`} className='header-login-link undecorated'>{strings.PARENT_PORTAL_HEADER_LOGIN_LINK}</a>
                    <a href={`/signup/?${getUrlParameters()}`} className='header-trial-cta undecorated'>{strings.PARENT_PORTAL_HEADER_START_TRIAL}</a>
                </div>
            </div>
        </header>
    )
}

export default withRouter(SchoolZoneHeader)
